<template>
  <div class="dim loading1" v-if="isShow" style="z-index: 15"></div>
  <div class="lds-facebook" v-if="isShow" style="z-index: 15">
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
import { computed, reactive, toRefs, watch } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'loading',
  setup() {
    const { getters } = useStore()
    const state = reactive({
      isLoading: computed(() => getters['layout/getIsLoading']),
      isShow: false,
      timer: ''
    })
    /** watch **/
    watch(
      () => state.isLoading,
      (val) => {
        if (state.timer) {
          clearTimeout(state.timer)
          state.timer = ''
        }
        if (val) {
          state.isShow = true
        } else {
          state.timer = setTimeout(() => {
            state.isShow = false
          }, 300)
        }
      }
    )
    return { ...toRefs(state) }
  }
}
</script>

<style>
.loading1 {
  display: block !important;
  height: 100vmax !important;
}
.lds-facebook {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  top: calc(50% - 32px);
  left: calc(50% - 32px);
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 6px;
  width: 13px;
  background: #008dd0;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.lds-facebook div:nth-child(1) {
  left: 6px;
  animation-delay: -0.24s;
}
.lds-facebook div:nth-child(2) {
  left: 26px;
  animation-delay: -0.12s;
}
.lds-facebook div:nth-child(3) {
  left: 45px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 6px;
    height: 51px;
  }
  50%,
  100% {
    top: 19px;
    height: 26px;
  }
}
</style>
